<template>
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-else>
        <v-row>
            <v-col xs="12" sm="12" md="8" lg="10" xl="10" cols="12">
                <div class="title_page ma-3">
                    <h4 class="breadcrumb_title_page">ซัพพลายเออร์</h4>
                    <v-breadcrumbs :items="sub_menu">
                        <template v-slot:divider>
                            <v-icon>mdi-chevron-right</v-icon>
                        </template>
                    </v-breadcrumbs>
                </div>
            </v-col>
            <v-col xs="12" sm="12" md="4" lg="2" xl="2" cols="12">
                <div class="title_page ma-3">
                    <v-btn type="button" class="btn_add_data" elevation="4" @click="link('/arin/pos/AddposSupplier')"
                        large>เพิ่มซัพพลายเออร์</v-btn>
                </div>
            </v-col>
        </v-row>

        <v-card>
            <v-row>
                <v-col xs="12" sm="6" md="8" lg="8" xl="8" cols="12">
                    <v-card-title style="color:#000;">รายการซัพพลายเออร์</v-card-title>
                </v-col>
                <v-col xs="12" sm="6" md="4" lg="4" xl="4" cols="12">
                    <v-text-field color="#D6BFAF" class="input-radius" append-icon="mdi-magnify" hide-details="auto"
                        required v-model="search" placeholder="ค้นหา..." single-line outlined dense></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                    <v-data-table :headers="headers" :items="data_list" :search="search" mobile-breakpoint="0">
                        <template v-slot:item="dataDetail">
                            <tr>
                                <td class="hidden_line">{{ dataDetail.item.department ? dataDetail.item.department : '-' }}
                                </td>
                                <td class="hidden_line">{{ dataDetail.item.name ? dataDetail.item.name : '-' }}</td>
                                <td class="hidden_line">{{ dataDetail.item.name_eng ? dataDetail.item.name_eng : '-' }}</td>
                                <td class="hidden_line">{{ dataDetail.item.short_name ? dataDetail.item.short_name : '-' }}</td>
                                <td class="hidden_line">
                                    <v-btn elevation="4" class="ma-2" color="#8EBBDC" title="ดูรายละเอียด" outlined
                                        height="45" small @click="dialog_detail(dataDetail.item.id);"
                                        style="border-radius:10px">
                                        <v-icon>mdi-magnify</v-icon>
                                    </v-btn>
                                    <v-btn elevation="4" class="ma-2" color="#FEA06C" title="แก้ไขรายละเอียด" outlined
                                        height="45" small @click="link('/arin/pos/editposSupplier/' + dataDetail.item.id)"
                                        style="border-radius:10px">
                                        <v-icon>mdi-pencil</v-icon>
                                    </v-btn>
                                    <v-btn elevation="4" class="ma-2" color="error" title="ลบข้อมูล" outlined height="45"
                                        small @click=" dialog_cancel(dataDetail.item.id);" style="border-radius:10px">
                                        <v-icon>mdi-trash-can-outline</v-icon>
                                    </v-btn>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-col>
                <v-dialog v-model="pos_dialog_detail" persistent max-width="650">
                    <v-card>
                        <div class="d-flex justify-space-between">
                            <v-card-title>
                                <b>รายละเอียดซัพพลายเออร์</b>
                            </v-card-title>
                            <v-btn icon class="ma-4" @click=" pos_dialog_detail = false">
                                <v-icon color="grey">mdi-close</v-icon>
                            </v-btn>
                        </div>
                        <v-card-text>
                            <v-row>
                                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                                    <!-- ข้อมูลซัพพลายเออร์ -->
                                    <div class="dialog_detail_supplier">
                                        <div class="d-flex">
                                            <div class="title_form_main">
                                                <div class="logo_timeline">
                                                    <img src="@/assets/arin_assets/company.png">
                                                </div>
                                            </div>
                                            <div class="header-content py-1 pl-5 pr-5 text-center">
                                                <div class="content-font">ข้อมูลซัพพลายเออร์</div>
                                            </div>
                                        </div>
                                        <div>ประเภท : <span style="color:#000;">{{data_detail.supplier_type == 1 ? 'บุคคลธรรมดา' : data_detail.supplier_type == 2 ? 'นิติบุคคล' : '-'}}</span></div>
                                    </div>
                                </v-col>
                                <v-col xs="12" sm="6" md="6" lg="6" xl="6" cols="12">
                                    <div>ชื่อแผนก : <span style="color:#000;">{{ data_detail.department ?
                                        data_detail.department : '-' }}</span></div>
                                </v-col>
                                <v-col xs="12" sm="6" md="6" lg="6" xl="6" cols="12">
                                    <div>อีเมล : <span style="color:#000;">{{  data_detail.email ?
                                        data_detail.email : '-' }}</span></div>
                                </v-col>
                                <v-col xs="12" sm="6" md="6" lg="6" xl="6" cols="12">
                                    <div>ชื่อ (ไทย) : <span style="color:#000;">{{  data_detail.name ?
                                        data_detail.name : '-' }}</span>
                                    </div>
                                </v-col>
                                <v-col xs="12" sm="6" md="6" lg="6" xl="6" cols="12">
                                    <div>ชื่อ (อังกฤษ) : <span style="color:#000;">{{ data_detail.name_eng ?
                                        data_detail.name_eng : '-' }}</span></div>
                                </v-col>
                                <v-col xs="12" sm="6" md="6" lg="6" xl="6" cols="12">
                                    <div>ชื่อย่อ : <span style="color:#000;">{{  data_detail.short_name ?
                                        data_detail.short_name : '-' }}</span></div>
                                </v-col>
                                <v-col xs="12" sm="6" md="6" lg="6" xl="6" cols="12">
                                    <div>เลขที่เสียภาษี : <span style="color:#000;">{{  data_detail.tax_number ?
                                        data_detail.tax_number : '-' }}</span>
                                    </div>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                                    <div class="d-flex">
                                        <div class="title_form_main">
                                            <div class="logo_timeline">
                                                <img src="@/assets/arin_assets/pin.png">
                                            </div>
                                        </div>
                                        <div class="header-content py-1 pl-5 pr-5 text-center">
                                            <div class="content-font">ที่อยู่</div>
                                        </div>
                                    </div>
                                </v-col>
                                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                                    <div>บ้านเลขที่/ที่อยู่ :
                                        <span v-if="data_detail.address !== null && data_detail.sub_districtw !== null"
                                            style="color:#000;">{{ data_detail.address }} {{ data_detail.sub_district
                                            }}</span>
                                        <span v-else style="color:#000;"> - </span>
                                    </div>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                                    <div class="d-flex">
                                        <div class="title_form_main">
                                            <div class="logo_timeline">
                                                <img src="@/assets/arin_assets/pin.png">
                                            </div>
                                        </div>
                                        <div class="header-content py-1 pl-5 pr-5 text-center">
                                            <div class="content-font">ข้อมูลผู้ติดต่อ</div>
                                        </div>
                                    </div>
                                </v-col>
                                <v-col xs="12" sm="6" md="6" lg="6" xl="6" cols="12">
                                    <div>ชื่อ - นามสกุล : <span style="color:#000;">{{ data_detail.name_contact ?
                                        data_detail.name_contact : '-' }}</span></div>
                                </v-col>
                                <v-col xs="12" sm="6" md="6" lg="6" xl="6" cols="12">
                                    <div>เบอร์โทร : <span style="color:#000;">{{ data_detail.telephone_contact ?
                                        data_detail.telephone_contact : '-' }}</span></div>
                                </v-col>
                            </v-row>
                        </v-card-text>

                    </v-card>
                </v-dialog>

                <v-dialog v-model="pos_dialog_cancel" persistent max-width="400">
                    <v-card>
                        <div class="d-flex justify-space-between">
                            <v-card-title>
                                <b>ลบข้อมูลซัพพลายเออร์</b>
                            </v-card-title>
                            <v-btn icon class="ma-4" @click=" pos_dialog_cancel = false">
                                <v-icon color="grey">mdi-close</v-icon>
                            </v-btn>
                        </div>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12">
                                    <center>
                                        <v-img height="80" max-width="80" :lazy-src="img_cancel_order"
                                            :src="img_cancel_order" class=" mt-3 mb-2"></v-img>
                                    </center>

                                </v-col>
                                <v-col cols="12" class="text-center">
                                    <h3>คุณต้องการข้อมูลซัพพลายเออร์หรือไม่ ?</h3>
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn type="button" @click="getSupplier_delete(dialog_modal_id)" class="btn_add_data"
                                elevation="4" large>ยืนยัน</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-row>
        </v-card>
    </div>
</template>

<script>
import { HTTP_ARIN } from "@/axios_arin";
import cancel_order from "@/assets/arin_assets/cancel_order.png";
import Swal from "sweetalert2";
export default {
    inject: {
        theme: {
            default: {
                isDark: false,
            },
        },
    },
    name: "Pos_product_list",
    data() {
        return {
            loading_page: false,
            img_cancel_order: cancel_order,
            search: '',
            pos_dialog_cancel: false,
            pos_dialog_detail: false,
            sub_menu: [
                {
                    text: 'ระบบ POS',
                    disabled: false,
                },
                {
                    text: 'ออกใบสั่งซื้อ',
                    disabled: false,
                },
                {
                    text: 'ซัพพลายเออร์​',
                    disabled: false,
                    href: '#',
                },
            ],
            headers: [
                {
                    text: 'แผนก',
                    value: 'department',
                    fixed: true,
                    sortable: false,
                },
                {
                    text: 'ชื่อ (ไทย)',
                    value: 'name',
                    fixed: true,
                    sortable: false,
                },
                {
                    text: 'ชื่อ (อังกฤษ)',
                    value: 'name_eng',
                    fixed: true,
                    sortable: false,
                },
                {
                    text: 'ชื่อย่อ',
                    value: '',
                    fixed: true,
                    sortable: false,
                },
                {
                    text: 'จัดการ',
                    value: '',
                    fixed: true,
                    sortable: false,
                },
            ],

            data_list: [],
            data_detail: [],
            dialog_modal_id: null,
        }
    },
    methods: {
        getSupplier_list() {
            const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
            HTTP_ARIN.get('/supplier', config).then((res) => {
                if (res.data.successful === true) {
                    this.loading_page = false;
                    this.data_list = res.data.supplier_list;
                }
            })
        },

        getSupplier_detail(id) {
            const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
            HTTP_ARIN.get('/supplier/supplierdetail/' + id, config).then((res) => {
                if (res.data.successful === true) {
                    this.loading_page = false;
                    this.data_detail = res.data.supplierDetail;
                }
            })
        },

        getSupplier_delete(id) {
            const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
            HTTP_ARIN.post('/supplier/delsupplier/' + id, null, config).then((res) => {
                if (res.data.successful === true) {
                    this.loading_page = false;
                    let timerInterval
                    Swal.fire({
                        title: 'เสร็จสิ้น',
                        text: 'ลบข้อมูลเรียบร้อยแล้ว',
                        icon: 'success',
                        timer: 2000,
                        timerProgressBar: true,
                        didOpen: () => {
                            Swal.showLoading()
                            timerInterval = setInterval(() => { }, 100)
                        },
                        willClose: () => {
                            clearInterval(timerInterval)
                            setTimeout(function () {
                                window.location.reload();
                            });
                        }
                    })
                } else {
                    Swal.fire({
                        title: 'ไม่สามารถลบข้อมูลได้ กรุณาลองใหม่อีกครั้ง!',
                        icon: 'error',
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonText: `ตกลง`,
                        denyButtonText: `ยกเลิก`,
                    })
                }
            })
        },

        link(link) {
            window.location.href = link;
        },

        dialog_detail(id) {
            this.getSupplier_detail(id);
            this.pos_dialog_detail = true;
        },

        dialog_cancel(id) {
            this.dialog_modal_id = id;
            this.pos_dialog_cancel = true;
        },

    },
    mounted() {
        this.getSupplier_list()
    }
}
</script>
<style>.dialog_detail_supplier {
    display: flex;
    justify-content: space-between;
    align-items: center;
}</style>
